<template>
  <div class="footer">
    <div class="footer-content">
      <p v-html="footerConfig.copyright_text"></p>
      <div v-if="footerConfig.links && footerConfig.links.length > 0" class="footer-links">
        <a v-for="link in footerConfig.links" :key="link.url" :href="link.url" target="_blank">
          {{ link.text }}
        </a>
      </div>
    </div>
    <div class="disclaimer">
      <p>免责声明：本站所有内容均来自第三方，本站不对内容的真实性、准确性、完整性负责。使用本站内容所产生的任何后果，本站不承担任何责任。</p>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'AppFooter',
  data() {
    return {
      footerConfig: {
        copyright_text: '© 2024 MKCases. All rights reserved.',
        links: []
      }
    }
  },
  mounted() {
    this.loadFooterConfig()
  },
  methods: {
    async loadFooterConfig() {
      try {
        const response = await api.get('/about/footer/')
        if (response.data) {
          if (Array.isArray(response.data) && response.data.length > 0) {
          this.footerConfig = response.data[0]
          } else if (!Array.isArray(response.data)) {
            this.footerConfig = response.data
          }
        }
      } catch (error) {
        console.error('加载页脚配置失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: rgba(10, 10, 10, 0.98) !important;
  padding: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  width: 100%;
}

.footer-content {
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
}

.footer-content p {
  color: rgba(255, 255, 255, 0.8);
}

.footer-links {
  margin-top: 10px;
}

.footer-links a {
  color: #00d4ff;
  text-decoration: none;
  margin: 0 10px;
  transition: all 0.3s ease;
}

.footer-links a:hover {
  color: #00ffff;
  text-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
  text-decoration: underline;
}

.disclaimer {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.disclaimer p {
  color: rgba(255, 255, 255, 0.6);
}
</style>

